import React, { useState } from 'react';
import Footer from "./Footer";
import axios from "axios";

import LeftFadeIn from "../components/animations/LeftFadeIn";
import SlideIn from "../components/animations/SlideIn";
import FadeIn from "../components/animations/FadeIn";


const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/adminuser/`
})

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        title: '',
        message: ''
    });

    const { name,  email, title, message } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit =async (e) => {
        e.preventDefault();
        let res= await api.post('/ContactUs/',formData)
        setFormData({ name:'', email: '',title: '',message: ''});
        res?.status === 201 ? alert("Message Sent! We will Contact You Soon") : alert("Oops! Something Went Wrong");
        
    };
    return(
    <>
    <div className='conainer row mt-5 contact-bg-image image-background'>
        <FadeIn>
            <h1 className='mt-4' style={{textAlign:'center', fontFamily:'argentecf', color: 'white'}}>Contact Us</h1>
            <h4 style={{textAlign:'center', color: 'white'}}> If you need any assistance please fill out this form for more queries.</h4>
        </FadeIn>
        <div className='w3-third ms-5 ps-5' style={{color: 'white', marginLeft: '20px', marginTop: '70px'}}>
            <LeftFadeIn>
            <h4 ><b><i className='fa fa-map-marker' style={{fontSize:'24px',color:'white'}}/>  Address : </b></h4>
            <p>
            BUILDEX .Ltd, ISLAMABAD
            </p>
            <br/>
            <h6><b><i className='fa fa-phone' style={{fontSize:'24px',color:'white'}}/>  Phone : </b></h6>
            <p>
            +923244307111
            </p>
            <br/>
            <h6><b><i className='fa fa-envelope' style={{fontSize:'24px',color:'white'}}/>  Email : </b></h6>
            <p>
            buildex.pakistan@gmail.com
            </p>
            </LeftFadeIn>
        </div>
        
        {/* <SlideIn> */}
            <div className='w3-half contact-form-container mt-5 px-5 box-shadow' style={{marginBottom: '60px', marginLeft: '250px'}}>
            <SlideIn>
                <h3>Send Message</h3>
                <form onSubmit={e => onSubmit(e)} className="mt-3">
                    <div className="mb-3">
                        <input type="text" className="form-control bottom-border-input" name='name' value={formData.name} style={{width:'350px'}} placeholder="Your Name *" onChange={e => onChange(e)} required/>
                    </div>
                    <div className="mb-3">
                        <input type="text" className="form-control bottom-border-input" name='email' value={formData.email} style={{width:'350px'}}  placeholder="Your Email *" onChange={e => onChange(e)} required/>
                    </div>
                    <div className="mb-3">
                        <input type="text" className="form-control bottom-border-input" name='title' value={formData.title} style={{width:'350px'}} placeholder="Title *" onChange={e => onChange(e)} required/>
                    </div>
                    <div className="mb-3">
                        <textarea className="form-control bottom-border-input" name='message' value={formData.message} placeholder="Message *" style={{height:'50px', width:'350px'}} onChange={e => onChange(e)} required />
                    </div>
                    <div className="form-group">
                        <button className='btn mt-3 send-message-btn' type='submit' style={{color: 'white', backgroundColor: '#2e2e1f',width: '150px',height:'50px', border: 'None'}}><b>Send Message</b></button>
                    </div>
                </form>
            </SlideIn>
            </div>
        {/* </SlideIn> */}
        
    </div>
    <Footer/>
    </>
    )
};
export default Contact;